import queryString from 'query-string';
import {Init} from "./types";
import config from './config';

const alloyId = 'alloy';
const alloyInitParams: Init = { key: '' };
let alloyCallback: (arg0: any) => void;
let iframeSrc: string;

const close = () => {
  const element = document.getElementById(alloyId);
  if (element && element.parentNode) {
    element.parentNode.removeChild(element);
  }
};

const init = ({
  key,
  entityToken,
  externalEntityId,
  evaluationData,
  production,
  maxEvaluationAttempts,
  documents,
  selfie,
  color,
  forceMobile
}: Init) => {
  alloyInitParams.key = key;
  if (entityToken) {
    alloyInitParams.entityToken = entityToken;
  }
  if (externalEntityId) {
    alloyInitParams.externalEntityId = externalEntityId;
  }
  if (production) {
    alloyInitParams.production = production;
  }
  if (maxEvaluationAttempts) {
    alloyInitParams.maxEvaluationAttempts = maxEvaluationAttempts;
  }
  if (documents) {
    alloyInitParams.documents = documents;
  }
  if (selfie) {
    alloyInitParams.selfie = selfie;
  }
  if (forceMobile) {
    alloyInitParams.forceMobile = forceMobile;
  }

  iframeSrc = `${queryString.stringify(alloyInitParams)}${evaluationData ? `&${queryString.stringify(evaluationData)}` : ''}${color ? `&${queryString.stringify(color)}` : ''}`;
  window.addEventListener('message', event => {
    if (event.origin !== 'https://alloy-test.z1.digital' || !alloyCallback) {
      return;
    }
    close();

    if (event.data !== 'close') {
      alloyCallback(event.data);
    }
  });
};

const open = (cb: () => void, anchorElement?: string) => {
  alloyCallback = cb;
  if (!alloyInitParams.key) {
    // eslint-disable-next-line no-console
    console.warn('The Alloy framework has not been initialized');
  } else {
    const alloyHeadStyles = document.getElementById('alloy-iframe-style');
    if (!alloyHeadStyles) {
      document.head.insertAdjacentHTML(
        'beforeend',
        `<style id="alloy-iframe-style">
        @keyframes fade {
          0%, 40% { opacity: 0 }
          80% { opacity: 1 }
        }
        .alloy-container {
          height: 100%;
          width: 100%;
          position: fixed;
          top: 0;
          transform: none;
          left: 0;
          z-index: 2;
        }
        @media (min-width: 768px) {
          .alloy-container {
            height: 37.5rem;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 50rem;
          }
        }
        .alloy-iframe {
            animation: fade 1.5s linear;
            border: 0;
            opacity: 1;
            height: 100%;
            max-height: 100%;
            width: 100%;
        }
        @media (min-width: 768px) {
            .alloy-iframe {
              border-radius: 1rem;
              box-shadow: 0 10px 20px 0 rgba(63,83,92,0.3);
              overflow: scroll;
            }
          }</style>`);
    }

    let container = document.getElementById(alloyId);
    if (!container) {
      container = document.createElement('div');
      container.className = 'alloy-container';
      const alloyIframe = document.createElement('iframe');
      alloyIframe.id = 'alloyIframe';
      alloyIframe.src = `${config.iframe}?${iframeSrc}`;
      alloyIframe.allow = 'camera';
      alloyIframe.className = 'alloy-iframe';
      container.id = alloyId;
      document.body.appendChild(container);
      container.append(alloyIframe);

      if (anchorElement && document.getElementById('alloy')) {
        const idAnchor = document.getElementById(anchorElement);
        const classAnchor = document.getElementsByClassName(anchorElement);
        if (idAnchor) {
          idAnchor.insertAdjacentElement('afterbegin', document.getElementById('alloy')!);
        } else if (classAnchor[0]) {
          classAnchor[0].insertAdjacentElement('afterbegin', document.getElementById('alloy')!);
        }
      }
    }
  }
};

const alloy = {
  init,
  open,
  close,
};

export default alloy;
